"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../index");

var _reactRouterDom = require("react-router-dom");

var _Dashboard = _interopRequireDefault(require("../../modules/dashboard/Dashboard"));

var _AppTopBar = _interopRequireDefault(require("../../components/layout/components/AppTopBar"));

var _AppSideBar = _interopRequireDefault(require("../../components/layout/components/AppSideBar"));

var _BreadcrumbHelper = _interopRequireDefault(require("../../util/BreadcrumbHelper"));

var _Breadcrumbs = _interopRequireDefault(require("../../components/elements/shared/Breadcrumbs"));

var _UserGroups = _interopRequireDefault(require("../../modules/push/UserGroups"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var DefaultLayout = /*#__PURE__*/function (_Component) {
  _inherits(DefaultLayout, _Component);

  function DefaultLayout(props) {
    var _this;

    _classCallCheck(this, DefaultLayout);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DefaultLayout).call(this, props));
    _this.state = {};
    return _this;
  }
  /**
   * Fast fix for top scrolling
   */


  _createClass(DefaultLayout, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      window.scrollTo(0, 0);
    }
    /**
     * Clear breacrumbs
     */

  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      _BreadcrumbHelper["default"].clearCrumbs();
    }
  }, {
    key: "_getInnerElements",
    value: function _getInnerElements() {
      var currentUrl = this.props.match.url;
      return _react["default"].createElement(_reactRouterDom.Switch, null, _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "cards"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/cards/Cards'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "push-notifications"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/push/PushNotificationsPage'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "legal"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/legal/LegalPage'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "terms"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/terms/TermsAndConditions'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "privacy"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/privacy/Privacy'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "reports/cards"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/reports/pages/cards/CardsReports'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "reports/totals"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/reports/pages/totals/TotalsReports'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "faq"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/faq/Faq'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "config"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/config/Config'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "countries"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/content-managament/countries/Countries'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "currencies"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/content-managament/currencies/Currencies'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "transaction-categories"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/content-managament/transaction-categories/TransactionCategories'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "merchant-category-code"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/content-managament/merchant-category-code/MerchantCategoryCode'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "transaction-merchant"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/content-managament/transaction-merchant/TransactionMerchant'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "push-notifications"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/push/PushNotificationsPage'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "user-groups"),
        component: _UserGroups["default"]
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "transaction"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/transactions/Transactions'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "kyc"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/kyc/KYC'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "users"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/users/UsersPage'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        path: "".concat(currentUrl, "tools"),
        load: function load() {
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('../../modules/tools'));
          });
        }
      }), _react["default"].createElement(_index.AppRoute, {
        exact: true,
        path: "".concat(currentUrl),
        component: _Dashboard["default"]
      }));
    }
    /**
     * Render default layout
     *
     * @returns {XML}
     */

  }, {
    key: "render",
    value: function render() {
      var innerElements = this._getInnerElements();

      return _react["default"].createElement("div", null, _react["default"].createElement(_AppTopBar["default"], null), _react["default"].createElement("div", {
        className: "dashboard"
      }, _react["default"].createElement(_AppSideBar["default"], null), _react["default"].createElement(_Breadcrumbs["default"], null), _react["default"].createElement("div", {
        className: "dashboard-main"
      }, innerElements), _react["default"].createElement("div", {
        className: "clear"
      })));
    }
  }]);

  return DefaultLayout;
}(_react.Component);

var _default = DefaultLayout;
exports["default"] = _default;